import { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "./layouts/Layout";
import ErrorBoundary from "./components/ErrorBoundary";
import "./App.css";

import HomePage from "./pages/HomePage";
const AnalyzePage = lazy(() => import("./pages/AnalyzePage"));
const ComparePage = lazy(() => import("./pages/ComparePage"));
const ScreenPage = lazy(() => import("./pages/ScreenPage"));
const NotFoundPage = lazy(() => import("./pages/NotFoundPage"));

export default function App() {
  return (
    <ErrorBoundary>
    <Suspense fallback={<div className="min-h-screen bg-[#f5f6f8] dark:bg-zinc-950" />}>
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/analyze/:company" element={<AnalyzePage />} />
          <Route path="/compare" element={<ComparePage />} />
          <Route path="/screen" element={<ScreenPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </Suspense>
    </ErrorBoundary>
  );
}
